import React, { FC, useEffect } from 'react';
import './DevicePrice.css';
import { PROCEED_BUTTON } from '../../../utils/constants';
import { countZero, getElementMaximumHeight } from '../../../utils/utils';

const DevicePrice: FC<any> = ({ priceCollection, proceedButtonIcon, cardIndex, totalLength }: any) => {

  useEffect(() => {
    findHeight();
    window.addEventListener('resize', findHeight);
  }, [priceCollection]);

  const findHeight = () => {
    getElementMaximumHeight('custDeviceDevicePriceWrapper', totalLength);
    getElementMaximumHeight('custDevicePriceSection', totalLength);
    getElementMaximumHeight('custDevicePrice', totalLength);
    getElementMaximumHeight('custDeviceDurationDetails', totalLength);
  };
  
  return (
    <div className='custDevicePriceWrapper' id={`custDeviceDevicePriceWrapper${cardIndex}`}>
      <div className='custDevicePriceAndButton d-flex' id={`custDevicePriceSection${cardIndex}`}>
        <div className='custDevicePriceAndDuration' id={`custDevicePrice${cardIndex}`}>
          <div>
            {/* price */}
            <span
              className={`custDeviceDiscountedPrice ${
                priceCollection?.discount && 'custDevicePromo'
              }`}
            >
              {countZero(
                priceCollection?.discount
                  ? priceCollection?.discountedPrice
                  : priceCollection?.actualPrice
              )}
              <span className='custDeviceCurrency'>
                {priceCollection?.priceTerm}
              </span>
            </span>
            {priceCollection?.discount && (
              <span className='custDeviceActualPrice'>
                {countZero(priceCollection?.actualPrice)}
              </span>
            )}
          </div>
          {/* duration */}
          <div className='custDeviceDuration' id={`custDeviceDurationDetails${cardIndex}`}>
            {priceCollection?.durationDetails}
          </div>
        </div>
        {/* button */}
        <div
          className={`ms-auto d-flex align-items-center custDevicePricebutton`}
        >
          <img
            className='custDeviceArrow'
            src={proceedButtonIcon}
            alt={PROCEED_BUTTON}
          />
        </div>
      </div>
      <div className='custDevicePriceLine'></div>
      {/* total price */}
      <div className='custDeviceTotalPrice'>
        {`${priceCollection?.totalPriceText} ${countZero(
          priceCollection?.discount
            ? priceCollection?.totalDiscount
            : priceCollection?.totalActual
        )}`}
        {priceCollection?.discount && (
          <span className='custDeviceTotalActual'>
            {countZero(priceCollection?.totalActual)}
          </span>
        )}
      </div>
    </div>
  );
};

export default DevicePrice;
